module.exports = __webpack_public_path__ + "static/media/puerta-sala-botero.ead91b78.jpg";